import React from 'react'
import Studentquizdetail from '../../components/student/quizdetail'
export default function QuizDetail() {
  return (
    <div>
        <Studentquizdetail/>
    </div>
  )
}
